/**
 * ReferralNotes — append-only progress log for a single REFERRAL.
 *
 * The third thin adapter over the shared <NotesLog> engine, beside
 * FileNotes.jsx (client files) and PrepNotes.jsx (preparation requests). It
 * wires the generic log to the referral notes store (referralNotesApi) and
 * nothing else: NotesLog.jsx, FileNotes.jsx and PrepNotes.jsx are untouched,
 * so the file and prep notepads behave exactly as before.
 *
 * Referral notes never require acknowledgement (referrals are Adviser-only,
 * so there is no counterpart role): referralNotesApi always writes
 * requires_ack = false, which means the engine never renders a "Mark as
 * read" control for these entries.
 */

import NotesLog from '../shared/NotesLog';
import { getNotesForReferral, createNote, acknowledgeNote, NOTE_BODY_MAX } from '../../api/referralNotesApi';

// Adapter mapping the generic NotesLog contract onto referralNotesApi.
// Module-scope so its identity stays stable across renders (NotesLog
// memoises its load/acknowledge callbacks on `api`).
const referralNotesAdapter = {
  getNotes: (referralId) => getNotesForReferral(referralId),
  createNote: ({ itemId, ...rest }) => createNote({ referralId: itemId, ...rest }),
  acknowledgeNote: (noteId) => acknowledgeNote(noteId),
};

export default function ReferralNotes({ referralId, currentUser, currentRole = null, refreshSignal = 0 }) {
  return (
    <NotesLog
      itemId={referralId}
      api={referralNotesAdapter}
      title="Notes"
      currentUser={currentUser}
      currentRole={currentRole}
      refreshSignal={refreshSignal}
      maxChars={NOTE_BODY_MAX}
    />
  );
}
